module.exports = __webpack_public_path__ + "img/tp1.0cf6727f.png";